import { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { ProtectedRoute } from "@/components/feature/ProtectedRoute";

const NotFound = lazy(() => import("../pages/NotFound"));
const ProfilePage = lazy(() => import("../pages/profile/page"));
const LoginPage = lazy(() => import("../pages/login/page"));
const DashboardPage = lazy(() => import("../pages/dashboard/page"));
const PatientsPage = lazy(() => import("../pages/patients/page"));
const ConsultationPage = lazy(() => import("../pages/consultation/page"));
const NewConsultationPage = lazy(() => import("../pages/new-consultation/page"));
const DocumentsPage = lazy(() => import("../pages/documents/page"));
const ConsultationsPage = lazy(() => import("../pages/consultations/page"));
const ConsultationReviewPage = lazy(() => import("../pages/consultation-review/page"));
const PatientDetailPage = lazy(() => import("../pages/patient-detail/page"));
const SettingsPage = lazy(() => import("../pages/settings/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const ClinicSettingsPage = lazy(() => import("../pages/clinic-settings/page"));
const TeamPage = lazy(() => import("../pages/team/page"));
const TutorsPage = lazy(() => import("../pages/tutors/page"));
const AiProvidersPage = lazy(() => import("../pages/ai-providers/page"));
const ProviderComparisonPage = lazy(() => import("../pages/ai-providers/benchmark-page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/patients",
    element: (
      <ProtectedRoute>
        <PatientsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/patients/:patientId",
    element: (
      <ProtectedRoute>
        <PatientDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/consultation/:patientId",
    element: (
      <ProtectedRoute>
        <ConsultationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/new-consultation",
    element: (
      <ProtectedRoute>
        <NewConsultationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/documents/:patientId",
    element: (
      <ProtectedRoute>
        <DocumentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/consultations",
    element: (
      <ProtectedRoute>
        <ConsultationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/consultation-review/:consultationId",
    element: (
      <ProtectedRoute>
        <ConsultationReviewPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/clinic-settings",
    element: (
      <ProtectedRoute>
        <ClinicSettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/team",
    element: (
      <ProtectedRoute>
        <TeamPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/tutors",
    element: (
      <ProtectedRoute>
        <TutorsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-providers",
    element: (
      <ProtectedRoute>
        <AiProvidersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-providers/benchmark",
    element: (
      <ProtectedRoute>
        <ProviderComparisonPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
